export const iconFontAwesomeShoppingCcStripe = (
	<i className="fa-solid fa-cc-stripe"></i>
);
